import { IconButton, Radio, RadioGroup, Stack, Text } from '@chakra-ui/react';
import { ServiceType } from '@prisma/client';
import { HiChevronLeft } from 'react-icons/hi';

import { QuoteFilters } from '.';

type Props = {
  filters: QuoteFilters;
  handleFilterChange: (key: string) => (nextValue: string) => void;
  resetView: () => void;
};

export const ServiceTypeFilter = ({ filters, handleFilterChange, resetView }: Props) => (
  <Stack>
    <Stack direction="row" align="center" spacing="2">
      <IconButton
        aria-label="Go back"
        icon={<HiChevronLeft />}
        variant="link"
        size="sm"
        display={{ base: 'flex', md: 'none' }}
        minW="auto"
        onClick={resetView}
      />
      <Text textStyle="label">Service Type</Text>
    </Stack>

    <RadioGroup value={filters?.serviceType} onChange={handleFilterChange('serviceType')}>
      <Stack>
        {Object.values(ServiceType).map((type) => (
          <Radio key={type} value={type}>
            {type}
          </Radio>
        ))}
      </Stack>
    </RadioGroup>
  </Stack>
);
